import { useForm } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { useParams } from 'libs/router'
import { routes } from 'config/routes'
import { BackButton, Form, Header, HistoryButton } from 'shared/components'
import { useAreaValidationSchema } from 'features/areas/hooks/useAreaValidationSchema'
import { AreaFormSections } from 'features/areas/organisms/AreaForm/AreaFormSections'
import { useEditAreaMutation } from './mutations/useEditAreaMutation'
import { useFetchArea } from './queries/useFetchArea'
import { usePopulateArea } from './hooks/usePopulateArea'

const AreaPage = () => {
	const { t } = useTranslation()
	const params = useParams()
	const validationResolver = useAreaValidationSchema()

	const form = useForm({
		mode: 'onChange',
		resolver: validationResolver
	})
	const { handleSubmit, reset } = form

	const { booth } = useFetchArea()

	usePopulateArea({
		data: booth?.data,
		reset
	})

	const { editAreaMutation, loadingEditArea } = useEditAreaMutation()

	const onSubmit = (data: any) => {
		editAreaMutation({
			booth_type: data.boothType.value,
			number: +data.number,
			is_active: data.is_active
		})
	}

	return (
		<>
			<Header
				title={t('Edit area')}
				eyebrow={t('Booking engine')}
				actions={
					<>
						<BackButton to={routes.areaIndex} text={t('Back to areas')} />
						<HistoryButton to={routes.areaHistory(params.id)} />
					</>
				}
			/>
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					submitText={t('Save changes')}
					cancelText={t('Discard changes')}
					onCancel={() => reset()}
					onSubmit={handleSubmit(onSubmit)}
					isLoading={loadingEditArea}>
					<AreaFormSections form={form} />
				</Form>
			</div>
		</>
	)
}

export default AreaPage
